
import { Link } from 'react-router'
import { useTranslation } from 'react-i18next';

import evenLinkLogo from 'assets/images/linkevent-logo.png';
import { Administrator, COUNTRIES } from 'shared/topchef.types'
import { useBackofficeCountry } from 'shared/BackofficeCountryContext';
import LanguageSelector from 'pages/shared/language-selector/LanguageSelector';

export interface BackofficeMenuProps {
  loggedInAdmin: Administrator,
}


const BackofficeMenu = ({loggedInAdmin}: BackofficeMenuProps) => {
  const { t } = useTranslation();
  const { selectedCountry, setSelectedCountry } = useBackofficeCountry();

  return (
    <>
      <div id="sidebar" className="d-flex flex-column flex-shrink-0 p-3 pt-5 bg-light vh-100 justify-content-between" style={{width: 200}}>
      <div className="row g-3">
        <div id="profil_sidebar">
          <div id="app_title" className="d-flex align-items-center">    
              <img src={evenLinkLogo} alt="LinkEvents logo" className="" style={{width: 150}} />
          </div>
          <LanguageSelector />
          <div id="host_infos" className="row gap-1 mt-3">
              <span className="listing-name fw-bold">{loggedInAdmin.name}</span>
          </div>
          <div id="country_selector" className="mt-3">
            <label htmlFor="bo_country_select" className="form-label small fw-semibold mb-1">
              {t('backoffice.country')}
            </label>
            <select
              id="bo_country_select"
              className="form-select form-select-sm"
              value={selectedCountry.code}
              onChange={(e) => {
                const found = COUNTRIES.find((c) => c.code === e.target.value);
                if (found) setSelectedCountry(found);
              }}
            >
              {COUNTRIES.map((c) => (
                <option key={c.code} value={c.code}>{t(`countries.${c.code}`)}</option>
              ))}
            </select>
          </div>
        </div>
          <div id="dashboard_sidebar">
            <span className="text-left">{t('nav.dashboard')}</span>
            <ul className="nav nav-pills flex-column mb-auto">
                <li className="nav-item"><Link to={'dashboard'} className="nav-link bo-dashboard-link">{t('nav.dashboard')}</Link></li>
                <li className="nav-item"> <Link to={'leads/all'} className="nav-link bo-all-briefs">{t('nav.allBriefs')}</Link></li>
                <li className="nav-item"> <Link to={'leads/to-validate'} className="nav-link bo-leads-to-validate-link">{t('nav.briefsToValidate')}</Link></li>
                <li className="nav-item"> <Link to={'leads/bills-to-validate'} className="nav-link bo-bills-to-validate-link">{t('nav.billsToValidate')}</Link></li>
                <li className="nav-item"> <Link to={'actived-places'} className="nav-link bo-actived-places-link">{t('nav.activatedAccounts')}</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </>
    
  );

}

export default BackofficeMenu;
